import { InlineText1, LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsOfferPageRedesign } from 'shared/selectors';

import { trackAdvantagesItemClick, trackNewbuildingLinkClick } from './tracking';
import { Advantages } from '../../components/Advantages';
import { Content, FullscreenPopup, Header } from '../../components/Advantages/components/FullscreenPopup';
import { NewbuildingAdvantagesContainer } from '../../components/NewbuildingAdvantages/NewbuildingAdvantagesContainer';
import {
  getGaLabel,
  getNewbuildingAdvantages,
  getNewbuildingLink,
  getNewbuildingName,
} from '../../selectors/newObject';
import { IAdvantage } from '../../types/newobject/newbuildingAdvantages';
import { NewbuildingSpecifications } from '../NewbuildingSpecifications/NewbuildingSpecifications';

export interface INewbuildingAdvantagesProps {
  showHeader?: boolean;
}

const NewbuildingAdvantages = ({ showHeader = true }: INewbuildingAdvantagesProps) => {
  const name = useSelector(getNewbuildingName);
  const advantages: IAdvantage[] = useSelector(getNewbuildingAdvantages);
  const newbuildingLink = useSelector(getNewbuildingLink);
  const gaLabel = useSelector(getGaLabel);
  const redesignPage = useSelector(selectIsOfferPageRedesign);

  const [isOpened, setOpenedState] = React.useState(false);
  const [advantageIndex, setAdvantageIndex] = React.useState(0);

  const onItemClick = React.useCallback(
    (i: number) => {
      setAdvantageIndex(i);
      setOpenedState(true);

      const item = advantages[i];
      if (item) {
        trackAdvantagesItemClick(item.advantageType);
      }
    },
    [setOpenedState, setAdvantageIndex, advantages],
  );

  const onNewbuildingLinkClick = React.useCallback(() => trackNewbuildingLinkClick(gaLabel), []);

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  if (!advantages || advantages.length === 0) {
    return null;
  }

  const advantage = advantages[advantageIndex];

  return (
    <NewbuildingAdvantagesContainer redesignPage={redesignPage} name={name} showHeader={showHeader}>
      <NewbuildingSpecifications />
      <Advantages redesignPage={redesignPage} advantages={advantages} onItemClick={onItemClick} />
      <FullscreenPopup
        isOpened={isOpened}
        header={<Header onClose={onClose} title={<InlineText1>ЖК «{name}»</InlineText1>} />}
        onClose={onClose}
        content={<Content {...advantage} />}
      />

      <LinkButton
        target="_blank"
        href={newbuildingLink}
        size="XS"
        theme="stroke_primary"
        onClick={onNewbuildingLinkClick}
      >
        Подробнее о жилом комплексе
      </LinkButton>
    </NewbuildingAdvantagesContainer>
  );
};

// eslint-disable-next-line import/no-default-export
export default NewbuildingAdvantages;
